import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const LabelWrapper = styled.div<{ $fontWeight?: number }>`
    ${styledTypography.truncate};
    flex: 1 1 auto;
    // TODO: Should use typography reset.
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : 500)};
    line-height: 1.2;
    font-size: 1rem;
    letter-spacing: -0.03em;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        font-size: 14px;
        line-height: 1;
    }
`;

export const LabelSuffix = styled.span`
    font-size: 12px;
    padding: 3px 4px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 100px;
`;
